export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}
export enum Locales {
  EN = "en",
  TH = "th",
}

export enum PrefixNameType {
  None = 0,
  Khun = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum DepartmentType {
  None = 0,
  GeneralManagement = 1,
  GeneralAdministration = 2,
  Sales = 3,
  Marketing = 4,
  Accounting = 5,
  Finance = 6,
  HumanResource = 7,
  Production = 8,
  Operation = 9,
  InformationTechnology = 10,
  Purchasing = 11,
  ResearchAndDevelopment = 12,
  Other = 13,
}

export enum BankReferenceType {
  NONE = -1,
  OTHER = 0,
  BBL = 1,
  KBANK = 2,
  SCB = 3,
  SME = 4,
  KTB = 5,
  BAY = 6,
  KK = 7,
  CIMB = 8,
  TMB = 9,
  TISCO = 10,
  TCR = 11,
  TCAP = 12,
  BAAC = 13,
  EXIM = 14,
  UOB = 15,
  LHBANK = 16,
  SCBT = 17,
  GSB = 18,
  IBANK = 20,
  ICBC = 21,
  JPMORGAN = 22,
  CITIBANK = 23,
  SMBC = 24,
  DB = 25,
  BNP = 26,
  MIZUHO = 27,
  THAIPR = 28,
  BOC = 29,
  BOA = 30,
  RBS = 31,
  RHB = 32,
  IOB = 33,
  HSBC = 34,
  ANZ = 35,
  OCBC = 36,
  GHBANK = 37,
}

export enum AddressSource {
  NA = 0,
  RD = 1,
  Corporate = 2,
  SmeLink = 3,
}

export enum AddressType {
  NoAddress = 0,
  Building = 1,
  HomeGroup = 2,
  Other = 3,
}

export enum TypeOfPerson {
  OrdinaryPerson = 1,
  JuristicPerson = 2,
}

export enum MerchantType {
  None = 0,
  LimitedLiabilityPartnership = 1,
  CompanyLimited = 2,
  PublicCompanyLimited = 3,
  Shop = 4,
  OrdinaryPerson = 5,
  BodyOfPersons = 6,
  Others = 7,
  OrdinaryPartnership = 8,
  Foundation = 9,
  Association = 10,
  JointVenture = 11,
}

export enum PeakExceptionResponseCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  ImportTransactionExceed = 43,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
}

export enum ContactDuplicateType {
  None = 0,
  TaxId = 1,
  Name = 2,
}

export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
}

export enum DocumentCreateType {
  None = 0,
  Create = 1,
  Edit = 2,
}

export enum TransactionType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  Dailyjournal = 11,
  WithholdingTax = 12,
}

export enum FinanceType {
  None = 0,
  InFlow = 1,
  OutFlow = 2,
}

export enum ExpenseType {
  None = 0,
  Expense = 1,
  PurchaseInventory = 2,
  PurchaseAsset = 3,
}

export enum WhtAmountType {
  Auto = -3,
  NotSpecify = -2,
  None = -1,
  Custom = 0,
  ZeroPointSevenFive = 1,
  OnePercent = 2,
  TwoPercent = 3,
  ThreePercent = 4,
  FivePercent = 5,
  TenPercent = 7,
  FifteenPercent = 8,
  OnePointFivePercent = 9,
}

export enum PaymentOption {
  None = 0,
  Standard = 1,
  Advance = 2,
}

export enum ProductVatType {
  NotDefined = 0,
  None = 1,
  ZeroPercent = 2,
  SevenPercent = 3,
}

export enum TaxTypeId {
  None = 2,
  ExcludeTax = 0,
  IncludeTax = 1,
}

export enum ProductTemplateType {
  None = 0,
  Product = 1,
  Service = 2,
}
export enum DiscountType {
  Currency = 0,
  Percent = 1,
}

export enum CurrencyCode {
  THB = 0,
  USD = 1,
  GBP = 2,
  EUR = 3,
  JPY = 4,
  HKD = 5,
  MYR = 6,
  SGD = 7,
  BND = 8,
  PHP = 9,
  IDR = 10,
  INR = 11,
  CHF = 12,
  AUD = 13,
  NZD = 14,
  CAD = 15,
  SEK = 16,
  DKK = 17,
  NOK = 18,
  CNY = 19,
  MXN = 20,
  ZAR = 21,
  KRW = 22,
  TWD = 23,
  KWD = 24,
  SAR = 25,
  AED = 26,
  MMK = 27,
  BDT = 28,
  CZK = 29,
  KHR = 30,
  KES = 31,
  LAK = 32,
  RUB = 33,
  VND = 34,
  EGP = 35,
  PLN = 36,
  LKR = 37,
  IQD = 38,
  BHD = 39,
  OMR = 40,
  JOD = 41,
  QAR = 42,
  MVR = 43,
  NPR = 44,
  PGK = 45,
  ILS = 46,
  HUF = 47,
  PKR = 48,
}

export enum PaymentInOutFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum BankAccountType {
  Cash = 0,
  Bank = 1,
  ExpenseClaim = 2,
  WithheldTax = 3,
  WithholdingTax = 4,
}

export enum WhtDeductType {
  None = 0,
  WitholdAtSource = 1,
  PayEveryTime = 2,
  PayOneTime = 3,
}

export enum PndType {
  None = 0,
  PND1kor = 1,
  PND2Specialkor = 2,
  PND2 = 3,
  PND3 = 4,
  PND2kor = 5,
  PND3kor = 6,
  PND53 = 7,
}
/* eslint-disable @typescript-eslint/camelcase */
export enum TaxIncomeType {
  None = 0,
  TaxIncomeType40_1_1 = 1,
  TaxIncomeType40_1_2 = 2,
  TaxIncomeType40_12 = 3,
  TaxIncomeType40_2 = 4,
  TaxIncomeType40_3 = 5,
  TaxIncomeType40_4_A = 6,
  TaxIncomeType40_4_B = 7,
  TaxIncomeType40_4_C = 8,
  TaxIncomeType40_4_D = 9,
  TaxIncomeType40_4_E = 10,
  TaxIncomeType40_4_F = 11,
  TaxIncomeType40_4_G = 12,
  TaxIncomeType40_5 = 13,
  TaxIncomeType40_6 = 14,
  TaxIncomeType40_7 = 15,
  TaxIncomeType40_8_1 = 16,
  TaxIncomeType40_8_2 = 17,
  TaxIncomeType40_8_3 = 18,
  TaxIncomeType40_8_4 = 19,
  TaxIncomeType40_8_5 = 20,
  TaxIncomeType40_8_6 = 21,
  TaxIncomeType40_8_7 = 22,
  TaxIncomeType40_8_8 = 23,
}

export enum InvoiceStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Outstanding = 4,
  Overdue = 5,
  PaidOrAwaitReceipt = 6,
  GotReceipt = 7,
}

export enum QuotationStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  AwaitResponse = 4,
  Expired = 5,
  ApprovedOrAccepted = 6,
}

export enum ExcludedAccountCodeFromCreateTransaction {
  Cash = 111101,
  CurrentAccounts = 111201,
  SavingAccounts = 111301,
  UncashedCheques = 111401,
  FixedDeposites = 112101,
  AccountsReceivable = 113101,
  ChequesReceivedInAdvance = 113102,
  AccountsPayable = 212101,
  ChequesPayable = 212102,
}

export enum BankType {
  None = 0,
  CurrentAccount = 1,
  SavingAccount = 2,
  FixedDeposit = 3,
}

export enum UserRight {
  None = 0,
  ViewOnly = 1,
  RevenueExpenseDraftOnly = 2,
  RevenueExpenseApproveOnly = 3,
  RevenueAll = 4,
  ExpenseAll = 5,
  QuotationOnly = 6,
  Standard = 7,
  BasicAndAdmin = 8,
  CreateRevenueOnly = 9,
  CreateExpenseOnly = 10,
  PurchaseOrderOnly = 11,
  RevenueDraftOnly = 12,
  ExpenseDraftOnly = 13,
  RevenueApproveOnly = 14,
  ExpenseApproveOnly = 15,
  QuotationDraftOnly = 16,
  QuotationApproveOnly = 17,
  PurchaseOrderDraftOnly = 18,
  PurchaseOrderApproveOnly = 19,
  ExpenseExceptPOAll = 20,
  RevenueExceptQOAll = 21,
  RevenueExpenseExceptQOandPOApproveOnly = 22,
}

export enum ContactUserRoleType {
  None = 0,
  All = 1,
  ContactAccessAndAddContact = 2,
  ContactAccessAndEditContact = 3,
  ContactAccessAndDeleteContact = 4,
  ContactAccessAndExportContact = 5,
  ContactAccessAddAndEditContact = 6,
  ContactAccessAddAndDeleteContact = 7,
  ContactAccessAddAndExportContact = 8,
  ContactAccessEditAndDeleteContact = 9,
  ContactAccessEditAndExportContact = 10,
  ContactAccessDeleteAndExportContact = 11,
  AddAndEditContact = 12,
  AddAndDeleteContact = 13,
  AddAndExportContact = 14,
  AddEditAndDeleteContact = 15,
  AddEditAndExportContact = 16,
  AddDeleteAndExportContact = 17,
  EditAndDeleteContact = 18,
  EditAndExportContact = 19,
  AddEditDeleteAndExportContact = 20,
  DeleteAndExportContact = 21,
  DeleteExportAndEditContact = 22,
  ContactAccess = 23,
  AddContact = 24,
  EditContact = 25,
  DeleteContact = 26,
  ExportContact = 27,
  ContactAccessAddEditAndDeleteContact = 28,
  ContactAccessAddEditAndExportContact = 29,
  ContactAccessAddDeleteAndExportContact = 30,
  ContactAccessEditDeleteAndExportContact = 31,
}

export enum FinanceAndAccountRights {
  None = 0,
  All = 1,
  FinanceAccessOnly = 2,
  GLAndStatementOnly = 3,
  DailyJournalsAll = 4,
  DailyJournalsDraftOnly = 5,
  DailyJournalsApproveOnly = 6,
  DailyJournalsAllAndFinance = 7,
  DailyJournalsDraftOnlyAndFinance = 8,
  DailyJournalsApproveOnlyAndFinance = 9,
  DailyJournalsAllAndGL = 10,
  DailyJournalsDraftOnlyAndGL = 11,
  DailyJournalsApproveOnlyAndGL = 12,
  FinanceAccountAndDailyJournalsDraftOnly = 13,
  FinanceAccountAndDailyJournalsApproveOnly = 14,
  FinanceAndGL = 15,
}

export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}

export enum DocumentType {
  None = 0,
  Create = 1,
  Edit = 2,
}

export enum ReceiptStatus {
  None = 0,
  Voided = 1,
  Draft = 2,
  AwaitApproval = 3,
  Approved = 4,
}

export enum DueDateSettingType {
  None = 0,
  DateDistanct = 1,
  DateDistanctNextMonth = 2,
  EndOfMonth = 3,
  EndOfMonthFromNextMonth = 4,
}

export enum ClassificationDocumentFinanceType {
  All = 0,
  Income = 1,
  Expense = 2,
}

export enum IconClassificationItem {
  GraphBar1 = 1,
  Pin1 = 2,
  Star1 = 3,
  GraphBar2 = 4,
  Percentage = 5,
  Wallet = 6,
  Document = 7,
  Building = 8,
  Suitcase = 9,
  Location = 10,
  Plane = 11,
  PieChart = 12,
  MultiUsers = 13,
  Shopping = 14,
  Merchant = 15,
  Box = 16,
  MailBox = 17,
  Receipt = 18,
  Approve = 19,
  Windmill = 20,
  Lock = 21,
  Study = 22,
  Folder = 23,
  PaperPlane = 24,
  Goal = 25,
  ArrowRight = 26,
  Book = 27,
  Wrench = 28,
  Destination = 29,
  Coin = 30,
  Car = 31,
  Note = 32,
  Gift = 33,
  Education = 34,
  Handshake = 35,
  Health = 36,
  Home = 37,
  Idea = 38,
  Annouce = 39,
  Meeting = 40,
  Pint2 = 41,
  TreeChart = 42,
  Brush = 43,
  Piggy = 44,
  Achrive = 45,
  Calculator = 46,
  Subway = 47,
  Label = 48,
  Shopee = 49,
  Lazada = 50,
  Facebook = 51,
  Line = 52,
  Internet = 53,
  Laptop = 54,
}

export enum AllocationValueType {
  Amount = 0,
  Percent = 1,
}

export enum ProductType {
  Inventory = 1,
  Service = 2,
}

export enum PeakSource {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
}
/* eslint-disable @typescript-eslint/camelcase */
export enum ActivityLogSource {
  None = 0,
  PEAK_Engine = 1,
  PEAK_Experience = 2,
  PEAK_API = 3,
  TransactionImport = 4,
  ZORT = 5,
  KetShopWeb = 6,
  XCommerce = 7,
  BentoWeb = 8,
  Wisible = 9,
  Empeo = 10,
  Recurring = 11,
  BoxMe = 12,
  PeakAsset = 13,
  LineConnect = 14,
  UCommerce = 15,
  Page365 = 16,
  PeakPayroll = 17,
  PeakBoard = 18,
  PeakTax = 19,
}

export enum SourceTypeProject {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
}

export enum SettingTaxInvoiceType {
  None = 0,
  IssueTaxInvoice = 1,
  NotIssueTaxInvoice = 2,
  AutoIssueTaxInvoice = 3,
}
export enum DailyJournalsRightType {
  None = 0,
  DraftOnly = 1,
  ApproveOnly = 2,
  All = 3,
}
export enum TransferFeeDeductType {
  None = 0,
  WithDrawalAccount = 1,
  DepositeAccount = 2,
}
export enum TransactionItemType {
  None = 0,
  Account = 1,
  Inventory = 2,
  Asset = 3,
}

export enum AuthenticationApplication {
  None = 0,
  PeakEngine = 1,
  PeakExperience = 2,
  PeakAsset = 3,
  PeakPayroll = 4,
  PeakBoard = 5,
  PeakTax = 6,
  PeakLineConnect = 7,
  PeakMobile = 8,
  PeakApi = 9,
}
